import { render, staticRenderFns } from "./GameRegistration.vue?vue&type=template&id=2c479e5f&scoped=true&"
import script from "./GameRegistration.vue?vue&type=script&lang=js&"
export * from "./GameRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c479e5f",
  null
  
)

export default component.exports